export const useStyles = (theme) => ({
  paper: {
    padding: 10,
    textAlign: "center",
  },
  feeRoot: {
    padding: 10,
    display: "flex",
    alignItems: "center",
    border: `1px solid #181818`,
    [theme.breakpoints.down(960)]: {
      flexDirection: "column",
    },
  },
  tableStyle: {
    border: `1px solid #181818`,
  },
  listitemRoot: {
    display: "flex",
    [theme.breakpoints.down(960)]: {
      flexDirection: "column",
    },
  },
});
